/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Wrapper, WrapperInterface } from "../../contracts/Wrapper";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_swapERC20Contract",
        type: "address",
      },
      {
        internalType: "address",
        name: "_wethContract",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "senderWallet",
        type: "address",
      },
    ],
    name: "WrappedSwapFor",
    type: "event",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swapERC20Contract",
        type: "address",
      },
    ],
    name: "setSwapERC20Contract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "signerWallet",
        type: "address",
      },
      {
        internalType: "address",
        name: "signerToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "signerAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "senderToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "senderAmount",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "swap",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "signerWallet",
        type: "address",
      },
      {
        internalType: "address",
        name: "signerToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "signerAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "senderToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "senderAmount",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "swapAnySender",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "swapERC20Contract",
    outputs: [
      {
        internalType: "contract ISwapERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "wethContract",
    outputs: [
      {
        internalType: "contract IWETH",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type WrapperConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WrapperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Wrapper__factory extends ContractFactory {
  constructor(...args: WrapperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _swapERC20Contract: string,
    _wethContract: string,
    overrides?: Overrides & { from?: string }
  ): Promise<Wrapper> {
    return super.deploy(
      _swapERC20Contract,
      _wethContract,
      overrides || {}
    ) as Promise<Wrapper>;
  }
  override getDeployTransaction(
    _swapERC20Contract: string,
    _wethContract: string,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _swapERC20Contract,
      _wethContract,
      overrides || {}
    );
  }
  override attach(address: string): Wrapper {
    return super.attach(address) as Wrapper;
  }
  override connect(signer: Signer): Wrapper__factory {
    return super.connect(signer) as Wrapper__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WrapperInterface {
    return new utils.Interface(_abi) as WrapperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Wrapper {
    return new Contract(address, _abi, signerOrProvider) as Wrapper;
  }
}
